import React, { useState } from "react";

interface Props {}
const BreedsContainer: React.FC<Props> = ({}) => {
  return (
    <div className="all-breeds">
      <h4 className="all-breeds__subtitle hidden"></h4>
      <div className="all-breeds__list">
        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="A"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/akita" title="Akita">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/209/card/500411981.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/209/card/500411981.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Akita</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/akita" title="Akita">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/akita/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/american-corgi"
              title="American Corgi"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/522/card/500411228.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/522/card/500411228.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>American Corgi</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/american-corgi"
                    title="American Corgi"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/american-corgi/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/aussiedoodle" title="Aussiedoodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/404/card/500415692.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/404/card/500415692.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Aussiedoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/aussiedoodle"
                    title="Aussiedoodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/aussiedoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/australian-mountain-doodle"
              title="Australian Mountain Doodle"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/585/card/501721239.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/585/card/501721239.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Australian Mountain Doodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/australian-mountain-doodle"
                    title="Australian Mountain Doodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/australian-mountain-doodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/australian-shepherd"
              title="Australian Shepherd"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/258/card/500420369.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/258/card/500420369.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Australian Shepherd</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/australian-shepherd"
                    title="Australian Shepherd"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/australian-shepherd/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="B"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/basset-hound" title="Basset Hound">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/211/card/500416243.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/211/card/500416243.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Basset Hound</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/basset-hound"
                    title="Basset Hound"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/basset-hound/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/beagle" title="Beagle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/212/card/502400310.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/212/card/502400310.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Beagle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/beagle" title="Beagle">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/beagle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/bernedoodle" title="Bernedoodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/444/card/500611744.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/444/card/500611744.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Bernedoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/bernedoodle"
                    title="Bernedoodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/bernedoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/bernese-mountain-dog"
              title="Bernese Mountain Dog"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/264/card/500415342.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/264/card/500415342.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Bernese Mountain Dog</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/bernese-mountain-dog"
                    title="Bernese Mountain Dog"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/bernese-mountain-dog/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/bichon-frise" title="Bichon Frise">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/218/card/500415401.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/218/card/500415401.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Bichon Frise</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/bichon-frise"
                    title="Bichon Frise"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/bichon-frise/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/bichonpoo" title="Bichonpoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/434/card/502473767.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/434/card/502473767.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Bichonpoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/bichonpoo" title="Bichonpoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/bichonpoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/boston-terrier"
              title="Boston Terrier"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/217/card/500411728.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/217/card/500411728.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Boston Terrier</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/boston-terrier"
                    title="Boston Terrier"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/boston-terrier/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/boxer" title="Boxer">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/216/card/500415693.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/216/card/500415693.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Boxer</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/boxer" title="Boxer">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/boxer/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/bulldog" title="Bulldog">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/214/card/500412403.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/214/card/500412403.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Bulldog</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/bulldog" title="Bulldog">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/bulldog/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="C"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/cairn-terrier"
              title="Cairn Terrier"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/274/card/500427255.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/274/card/500427255.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cairn Terrier</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/cairn-terrier"
                    title="Cairn Terrier"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cairn-terrier/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/cane-corso" title="Cane Corso">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/343/card/500411506.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/343/card/500411506.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cane Corso</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/cane-corso"
                    title="Cane Corso"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cane-corso/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/cavachon" title="Cavachon">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/385/card/500415532.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/385/card/500415532.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cavachon</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/cavachon" title="Cavachon">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cavachon/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/cavalier-king-charles-spaniel"
              title="Cavalier King Charles Spaniel"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/276/card/500416275.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/276/card/500416275.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cavalier King Charles Spaniel</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/cavalier-king-charles-spaniel"
                    title="Cavalier King Charles Spaniel"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cavalier-king-charles-spaniel/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/cavapoo" title="Cavapoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/390/card/500419164.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/390/card/500419164.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cavapoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/cavapoo" title="Cavapoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cavapoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/chihuahua" title="Chihuahua">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/219/card/500422328.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/219/card/500422328.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Chihuahua</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/chihuahua" title="Chihuahua">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/chihuahua/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/cockapoo" title="Cockapoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/347/card/500415579.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/347/card/500415579.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cockapoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/cockapoo" title="Cockapoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cockapoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/cocker-spaniel"
              title="Cocker Spaniel"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/220/card/500422902.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/220/card/500422902.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Cocker Spaniel</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/cocker-spaniel"
                    title="Cocker Spaniel"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/cocker-spaniel/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/collie" title="Collie">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/221/card/500412682.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/221/card/500412682.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Collie</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/collie" title="Collie">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/collie/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/corgipoo" title="Corgipoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/518/card/500014715.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/518/card/500014715.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Corgipoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/corgipoo" title="Corgipoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/corgipoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/coton-de-tulear"
              title="Coton de Tulear"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/285/card/500422814.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/285/card/500422814.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Coton de Tulear</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/coton-de-tulear"
                    title="Coton de Tulear"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/coton-de-tulear/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="D"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/dachshund" title="Dachshund">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/222/card/500416331.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/222/card/500416331.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Dachshund</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/dachshund" title="Dachshund">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/dachshund/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/doberman-pinscher"
              title="Doberman Pinscher"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/223/card/500423017.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/223/card/500423017.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Doberman Pinscher</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/doberman-pinscher"
                    title="Doberman Pinscher"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/doberman-pinscher/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/dogue-de-bordeaux"
              title="Dogue de Bordeaux"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/290/card/500413398.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/290/card/500413398.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Dogue de Bordeaux</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/dogue-de-bordeaux"
                    title="Dogue de Bordeaux"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/dogue-de-bordeaux/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="F"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/french-bulldog"
              title="French Bulldog"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/225/card/500461007.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/225/card/500461007.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>French Bulldog</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/french-bulldog"
                    title="French Bulldog"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/french-bulldog/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/frenchton" title="Frenchton">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/425/card/500413491.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/425/card/500413491.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Frenchton</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/frenchton" title="Frenchton">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/frenchton/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="G"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/german-shepherd-dog"
              title="German Shepherd Dog"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/226/card/500424518.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/226/card/500424518.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>German Shepherd Dog</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/german-shepherd-dog"
                    title="German Shepherd Dog"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/german-shepherd-dog/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/golden-retriever"
              title="Golden Retriever"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/228/card/500848096.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/228/card/500848096.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Golden Retriever</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/golden-retriever"
                    title="Golden Retriever"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/golden-retriever/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/goldendoodle" title="Goldendoodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/334/card/500786611.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/334/card/500786611.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Goldendoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/goldendoodle"
                    title="Goldendoodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/goldendoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/great-dane" title="Great Dane">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/299/card/500424690.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/299/card/500424690.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Great Dane</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/great-dane"
                    title="Great Dane"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/great-dane/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available designer"
          id="H"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/havachon" title="Havachon">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/406/card/500413452.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/406/card/500413452.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Havachon</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/havachon" title="Havachon">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/havachon/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/havamalt" title="Havamalt">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/484/card/500725592.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/484/card/500725592.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Havamalt</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/havamalt" title="Havamalt">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/havamalt/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>







        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/havanese" title="Havanese">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/302/card/500416459.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/302/card/500416459.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Havanese</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/havanese" title="Havanese">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/havanese/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/havapoo" title="Havapoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/447/card/500414241.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/447/card/500414241.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Havapoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/havapoo" title="Havapoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/havapoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card purebred purebred"
          id="J"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/russell-terrier"
              title="Jack Russell Terrier"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/230/card/500425884.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/230/card/500425884.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Jack Russell Terrier</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/russell-terrier"
                    title="Jack Russell Terrier"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/russell-terrier/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="K"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/keeshond" title="Keeshond">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/305/card/500000076.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/305/card/500000076.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Keeshond</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/keeshond" title="Keeshond">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/keeshond/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available designer"
          id="L"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/labradoodle" title="Labradoodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/327/card/500425943.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/327/card/500425943.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Labradoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/labradoodle"
                    title="Labradoodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/labradoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/labrador-retriever"
              title="Labrador Retriever"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/231/card/500421880.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/231/card/500421880.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Labrador Retriever</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/labrador-retriever"
                    title="Labrador Retriever"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/labrador-retriever/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="M"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/maltese" title="Maltese">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/232/card/500415464.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/232/card/500415464.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Maltese</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/maltese" title="Maltese">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/maltese/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/maltipoo" title="Maltipoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/345/card/500415501.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/345/card/500415501.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Maltipoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/maltipoo" title="Maltipoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/maltipoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/miniature-american-shepherd"
              title="Miniature American Shepherd"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/426/card/500414008.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/426/card/500414008.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Miniature American Shepherd</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/miniature-american-shepherd"
                    title="Miniature American Shepherd"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/miniature-american-shepherd/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/miniature-pinscher"
              title="Miniature Pinscher"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/233/card/500426430.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/233/card/500426430.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Miniature Pinscher</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/miniature-pinscher"
                    title="Miniature Pinscher"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/miniature-pinscher/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/miniature-schnauzer"
              title="Miniature Schnauzer"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/320/card/500411657.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/320/card/500411657.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Miniature Schnauzer</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/miniature-schnauzer"
                    title="Miniature Schnauzer"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/miniature-schnauzer/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/morkie" title="Morkie">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/367/card/500423431.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/367/card/500423431.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Morkie</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/morkie" title="Morkie">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/morkie/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="N"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/newfoundland" title="Newfoundland">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/286/card/500426812.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/286/card/500426812.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Newfoundland</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/newfoundland"
                    title="Newfoundland"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/newfoundland/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card purebred purebred"
          id="O"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/old-english-sheepdog"
              title="Old English Sheepdog"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/278/card/500427127.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/278/card/500427127.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Old English Sheepdog</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/old-english-sheepdog"
                    title="Old English Sheepdog"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/old-english-sheepdog/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="P"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/papillon" title="Papillon">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/235/card/500414318.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/235/card/500414318.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Papillon</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/papillon" title="Papillon">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/papillon/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/pekingese" title="Pekingese">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/236/card/500415128.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/236/card/500415128.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Pekingese</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/pekingese" title="Pekingese">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/pekingese/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/pembroke-welsh-corgi"
              title="Pembroke Welsh Corgi"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/324/card/500411700.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/324/card/500411700.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Pembroke Welsh Corgi</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/pembroke-welsh-corgi"
                    title="Pembroke Welsh Corgi"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/pembroke-welsh-corgi/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/pomapoo" title="Pomapoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/346/card/500419769.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/346/card/500419769.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Pomapoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/pomapoo" title="Pomapoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/pomapoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/pomeranian" title="Pomeranian">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/238/card/500427546.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/238/card/500427546.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Pomeranian</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/pomeranian"
                    title="Pomeranian"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/pomeranian/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/pomsky" title="Pomsky">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image ls-is-cached lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/437/card/500411751.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/437/card/500411751.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Pomsky</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/pomsky" title="Pomsky">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/pomsky/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/poodle" title="Poodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/322/card/500421875.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/322/card/500421875.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Poodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/poodle" title="Poodle">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/poodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/portuguese-water-dog"
              title="Portuguese Water Dog"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/275/card/500411788.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/275/card/500411788.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Portuguese Water Dog</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/portuguese-water-dog"
                    title="Portuguese Water Dog"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/portuguese-water-dog/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/pug" title="Pug">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/240/card/500415905.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/240/card/500415905.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Pug</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/pug" title="Pug">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/pug/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/puggle" title="Puggle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/341/card/500428558.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/341/card/500428558.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Puggle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/puggle" title="Puggle">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/puggle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card purebred purebred"
          id="R"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/rottweiler" title="Rottweiler">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/241/card/500415785.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/241/card/500415785.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Rottweiler</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/rottweiler"
                    title="Rottweiler"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/rottweiler/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available designer"
          id="S"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/saint-berdoodle"
              title="Saint Berdoodle"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/476/card/500422171.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/476/card/500422171.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Saint Berdoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/saint-berdoodle"
                    title="Saint Berdoodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/saint-berdoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/saint-bernard"
              title="Saint Bernard"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/270/card/500428489.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/270/card/500428489.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Saint Bernard</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/saint-bernard"
                    title="Saint Bernard"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/saint-bernard/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/samoyed" title="Samoyed">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/268/card/500431106.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/268/card/500431106.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Samoyed</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/samoyed" title="Samoyed">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/samoyed/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/schnoodle" title="Schnoodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/387/card/500415906.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/387/card/500415906.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Schnoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/schnoodle" title="Schnoodle">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/schnoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/scottish-terrier"
              title="Scottish Terrier"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/242/card/500427434.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/242/card/500427434.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Scottish Terrier</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/scottish-terrier"
                    title="Scottish Terrier"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/scottish-terrier/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/sheepadoodle" title="Sheepadoodle">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/415/card/502473808.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/415/card/502473808.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Sheepadoodle</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/sheepadoodle"
                    title="Sheepadoodle"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/sheepadoodle/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/shiba-inu" title="Shiba Inu">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/263/card/500429136.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/263/card/500429136.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Shiba Inu</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/shiba-inu" title="Shiba Inu">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/shiba-inu/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/shichon" title="Shichon">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/381/card/500422793.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/381/card/500422793.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Shichon</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/shichon" title="Shichon">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/shichon/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/shih-tzu" title="Shih Tzu">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/244/card/500415882.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/244/card/500415882.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Shih Tzu</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/shih-tzu" title="Shih Tzu">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/shih-tzu/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/shihpoo" title="Shihpoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/378/card/500411861.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/378/card/500411861.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Shihpoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/shihpoo" title="Shihpoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/shihpoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card designer">
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/shorkie" title="Shorkie">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/382/card/500415809.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/382/card/500415809.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Shorkie</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/shorkie" title="Shorkie">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/shorkie/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/siberian-husky"
              title="Siberian Husky"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/245/card/500429198.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/245/card/500429198.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Siberian Husky</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/siberian-husky"
                    title="Siberian Husky"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/siberian-husky/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card purebred purebred"
          id="V"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/vizsla" title="Vizsla">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/247/card/500429869.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/247/card/500429869.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Vizsla</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/vizsla" title="Vizsla">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/vizsla/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available purebred"
          id="W"
        >
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/west-highland-white-terrier"
              title="West Highland White Terrier"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/253/card/500422773.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/253/card/500422773.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>West Highland White Terrier</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/west-highland-white-terrier"
                    title="West Highland White Terrier"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/west-highland-white-terrier/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="breed-card__container js-breed-card both-available designer"
          id="Y"
        >
          <div className="breed-card">
            <a href="/puppies-for-sale/breed/yorkiepoo" title="Yorkiepoo">
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/344/card/500421873.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/344/card/500421873.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Yorkiepoo</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a href="/puppies-for-sale/breed/yorkiepoo" title="Yorkiepoo">
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/yorkiepoo/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="breed-card__container js-breed-card purebred">
          <div className="breed-card">
            <a
              href="/puppies-for-sale/breed/yorkshire-terrier"
              title="Yorkshire Terrier"
            >
              <picture className="">
                <img
                  id=""
                  alt=""
                  className="breed-card__image lazyloaded"
                  data-cy=""
                  data-src="https://photos.puppyspot.com/breeds/249/card/500427607.jpg"
                  loading="lazy"
                  src="https://photos.puppyspot.com/breeds/249/card/500427607.jpg"
                />
              </picture>
            </a>
            <div className="breed-card__copy">
              <h3>Yorkshire Terrier</h3>
              <div className="breed-card__ctas">
                <div className="cta-white small">
                  <a
                    href="/puppies-for-sale/breed/yorkshire-terrier"
                    title="Yorkshire Terrier"
                  >
                    See Puppies
                  </a>
                </div>
                <a
                  // href="/puppies-for-sale/breed/yorkshire-terrier/overview"
                  className="breed-card__ctas-overview"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="all-breeds__scrolltop js-back-to-top">Back to Top</div> */}
    </div>
  );
};

export default BreedsContainer;
